/*
 *[!] We can't use Vuex because of it's size and requiring us to include Vue in init.js script
 *So, we use custom simple realization of store
 */

// TODO It's need refactoring!

const state = {
    ui: {
        isCompletionsVisible: false,
        isImageSearchVisible: false,
        isImageSearchWidgetVisible: false,
        isImageContours: null,
        isFiltersOpened: false,
        isCategoriesListVisible: false,
        isVoiceSearchActive: false,
        currentVoiceSearchQuery: '',
        isShowSignature: false,
        isLoading: false,
        isShowAgeCheckPopup: false,
        isCategorySearch: false,
        isComplitionSearch: false,
        isImageSearchLoader: false,
        isNameWidgetActive: '',
        isSimilarSearchLoading: true,
        isSimilarSearchActive: false,
    },
    availableScrollToOffer: true,
    base64ImageResult: null,
    base64Image: null,
    isSearchError: false,
};

const mutations = {
    'ui/SET_PROPERTY': ({ key, value }) => {
        state.ui[key] = value;
    },
    'availableScrollToOffer/SET_PROPERTY': (value) => {
        state.availableScrollToOffer = value;
    },
    'base64ImageResult/SET_PROPERTY': (value) => {
        state.base64ImageResult = value;
    },
    'base64Image/SET_PROPERTY': (value) => {
        state.base64Image = value;
    },
};

export default {
    state: state,
    commit(name, payload) {
        if (typeof mutations[name] !== 'function') {
            console.warn(`Mutation "${name}" not found!`);
            return;
        }
        mutations[name](payload);
    },
};
